import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection, { faqs } from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

export default function IdahoFallsPage() {
  return (
    <div className="min-h-screen bg-white">
      <CitySEOHead
        city="Idaho Falls"
        state="Idaho"
        stateAbbr="ID"
        route="/idaho-falls"
        title="Expedited & Emergency Passport Services Idaho Falls ID | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Idaho Falls, Idaho. Serving Bonneville County, Ammon, Rexburg, Blackfoot, and eastern Idaho. As fast as 24 hours — no Salt Lake City agency trip needed."
        geoPlacename="Idaho Falls, Idaho"
        geoPosition="43.4917;-112.0339"
        faqs={faqsMapped}
        servicesSchema={[]}
        statePageName="Idaho"
        statePageRoute="/states/idaho"
      />
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
    </div>
  );
}